import { get, map, kebabCase } from 'lodash'

const _ALL = typeof Symbol === 'function' ? Symbol('_ALL') : '_ALL'

export class ProviderFactory {
  constructor () {
    this[_ALL] = get(require('@/data'), 'providers', [])
  }
  get all () {

    let all_providers = map(this[_ALL], p => {
      if(p.clients) {
        p.clients_list = map(p.clients.split('|'), r => {
          return r
        })
      }

      p.url = kebabCase(p.name)

      return p
    })

    return all_providers
  }

  static create () {
    return new ProviderFactory()
  }
}

export default new ProviderFactory()
